
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/communities",
      function () {
        return require("private-next-pages/communities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/communities"])
      });
    }
  